$(document).ready(function() {
    $('.js-modal-answer-correct').on('click', function() {
        $(this).addClass('correct');
        $(this).next('.b-modal-answers__item-answer').show();
        $('.b-modal-answers').addClass('show');
    });
    $('.js-modal-answer-wrong').on('click', function() {
        $(this).addClass('wrong');
        $(this).next('.b-modal-answers__item-answer').show();
        $('.b-modal-answers').addClass('show');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/game-one/game-answers.js